import { Typography } from '@/components/atoms/Typography';
import { DirhamIcon } from '@/components/atoms/icons/DirhamIcon';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface LastPaymentItemProps {
    propertyName: string;
    paymentDate: string;
    paymentDescription: string;
    amount: number;
}

export const LastPaymentItem = React.memo<LastPaymentItemProps>(function LastPaymentItem({
    propertyName,
    paymentDate,
    paymentDescription,
    amount,
}) {
    const colors = useUIColors();

    return (
        <View style={[styles.container, { borderColor: colors.outlineActive }]}>
            <Typography variant="subhead" color="primary" style={styles.title}>
                Last payment
            </Typography>

            <View style={styles.content}>
                <View style={styles.topRow}>
                    <Typography variant="subhead" color="tertiary" style={styles.propertyName}>
                        {propertyName}
                    </Typography>
                    <Typography variant="footnote" color="tertiary" style={styles.date}>
                        {paymentDate}
                    </Typography>
                </View>

                <View style={styles.bottomRow}>
                    <Typography variant="body" color="primary" style={styles.description}>
                        {paymentDescription}
                    </Typography>
                    <View style={[styles.amountContainer, { direction: 'ltr' }]}>
                        <DirhamIcon size={18} color={colors.fontPrimary} />
                        <Typography variant="headline" color="primary" style={styles.amount}>
                            {amount.toLocaleString()}
                        </Typography>
                    </View>
                </View>
            </View>
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        borderWidth: 1,
        borderRadius: 8,
        padding: 12,
        gap: 8,
    },
    title: {
        marginBottom: 0,
    },
    content: {
        gap: 4,
        height: 37,
        justifyContent: 'center',
    },
    topRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
    },
    propertyName: {
        flex: 1,
        marginBottom: 0,
    },
    date: {
        marginBottom: 0,
    },
    bottomRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
    },
    description: {
        flex: 1,
        marginBottom: 0,
    },
    amountContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    amount: {
        marginBottom: 0,
    },
});

export default LastPaymentItem;
